import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { 
    getRegions, 
    getCityByState, 
    getInventoryInitialData, 
    getCurrencyList, 
    getState, 
    getCategories, 
    getCityPincode ,
    getBrand,
    getSubCategories
  } from "../services/CommonService";

export const regionData = createAsyncThunk("/businesses/region", async (thunkAPI) => {
  try{
    const data = await getRegions();
    return data;
  }catch(exception){
    if (!exception.response) {
    return thunkAPI.rejectWithValue(exception)
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
});

export const getAllState = createAsyncThunk("/businesses/state", async (params, thunkAPI) => {
  try{
    const data = await getState(params);
    return data.data;
  }catch(exception){
    if (!exception.response) {
      return thunkAPI.rejectWithValue(exception)
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
});

export const CityByState = createAsyncThunk("/city/by-state-id", async (stateId, thunkAPI)=>{
  try{
    const data = await getCityByState(stateId)
    return data.data
  }catch(exception){
    if (!exception.response) {
      return thunkAPI.rejectWithValue(exception)
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
})

export const InventoryInitialData = createAsyncThunk("/inventory/initial-data", async (inventoryId) => {
  const data = await getInventoryInitialData(inventoryId);
  return data;
});

export const getCurrency = createAsyncThunk("/get.currency",async(thunkAPI)=>{
  try{
    const data = await getCurrencyList();
    console.log(data)
    return data.data;
  }catch(exception){
    if (!exception.response) {
    return exception
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }

})

export const getCatList = createAsyncThunk("/category/list", async (params, thunkAPI)=>{
  try{
      if(params.brandId){
        const data = await getCategories({brandId: params.brandId});  
        return data.data.docs;
      }else{
        let pageData =  Object.assign({}, params)
        pageData.page = pageData.page - 1  
        const data = await getCategories(pageData);  
        return data.data;
    }
      
      
  }catch(exception){
      if (!exception.response) {
          return exception
      }
      return thunkAPI.rejectWithValue(exception?.response?.data)
  }
});

export const cityPincode = createAsyncThunk("/city/pincode", async ({cityId, extraQueryStr }, thunkAPI)=>{
  try{
    const data = await getCityPincode(cityId, extraQueryStr)
    return data.data
  }catch(exception){
    if (!exception.response) {
      return thunkAPI.rejectWithValue(exception)
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
});

export const getBrands = createAsyncThunk("/brands", async (thunkAPI)=>{
  try{
    const data = await getBrand()
    return data
  }catch(exception){
    if (!exception.response) {
      return thunkAPI.rejectWithValue(exception)
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
});

export const getSubCategoriesList = createAsyncThunk("/category/sub", async ({ catId },thunkAPI)=>{
  try{
    const data = await getSubCategories({catId})
    return data.data
  }catch(exception){
    if (!exception.response) {
      return thunkAPI.rejectWithValue(exception)
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
});

const InitialSlice = createSlice({
  name:"InitialSlice",
  initialState:{
    loading: false,
    CommonData: [],
    RegionList: [],
    StateList: [],
    CitiesList: [],
    InventoryInit: [],
    categories: [],
    currencyList: [],
    pincodeList: [],
    brands: [],
    subCategories: [],
    success: false,
    error: "",
    message: false,
    googleMapApiLoaded: false,
    selectedModuleId: ""
  },
  reducers: {
    setGoogleMapApiLoaded: (state, action) => {
        state.googleMapApiLoaded = action.payload
    },
    setModuleId: (state, action) => {
      state.selectedModuleId = action.payload.moduleId;
    }
  },
  extraReducers:{
    [regionData.pending]:(state) => {
      state.loading = true
    },
    [regionData.rejected]:(state, action) => {
      state.success = false
      state.loading = false
      state.message = action.payload?.message
    },
    [regionData.fulfilled]:(state, action) => {
      state.success = true
      state.loading = false
      state.message = ""
      state.RegionList = action.payload.list
    },

    [getAllState.pending]:(state) => {
      state.loading = true
    },
    [getAllState.rejected]:(state, action) => {
      state.loading = false
      state.error = action.payload?.message
    },
    [getAllState.fulfilled]:(state, action) => {
      state.success = true
      state.loading = false
      state.StateList = action.payload
    },

    [CityByState.pending]:(state) => {
      state.loading = true
      state.error = ''
    },
    [CityByState.rejected]:(state, action) => {
      state.loading = false
      console.log(action)
      state.error = action.error.message
    },
    [CityByState.fulfilled]:(state, action) => {
      state.loading = false   
      state.CitiesList = action.payload
    },

    [InventoryInitialData.pending]:(state) => {
      state.loading = true
    },
    [InventoryInitialData.rejected]:(state, action) => {
      state.success = false
      state.message = action.payload?.message
    },
    [InventoryInitialData.fulfilled]:(state, action) => {
      state.success = true
      state.message = ""
      state.InventoryInit = action.payload.list
    },

    [getCurrency.pending]:(state) => {
      state.loading = true
    },
    [getCurrency.rejected]:(state, action) => {
      state.loading = false
      state.success = false
      state.message = action.payload?.message
    },
    [getCurrency.fulfilled]:(state, action) => {
      state.loading = false
      state.success = true
      state.message = ""
      state.currencyList = action.payload.list
    },

    [getCatList.pending]:(state) => {
      state.loading = true
    },
    [getCatList.rejected]:(state, action) => {
      state.loading = false
      state.success = false
      state.message = action.payload?.message
    },
    [getCatList.fulfilled]:(state, action) => {
      state.loading = false
      state.success = true
      state.message = ""
      state.categories = action.payload
    },

    [cityPincode.pending]:(state) => {
      state.loading = true
    },
    [cityPincode.rejected]:(state, action) => {
      state.loading = false
      state.success = false
      state.message = action.payload?.message
    },
    [cityPincode.fulfilled]:(state, action) => {
      state.loading = false
      state.success = true
      state.message = ""
      state.pincodeList = action.payload?.[0]?.['areas']
    },

    [getBrands.pending]:(state) => {
      state.loading = true
    },
    [getBrands.rejected]:(state, action) => {
      state.loading = false
      state.success = false
      state.message = action.payload?.message
    },
    [getBrands.fulfilled]:(state, action) => {
      state.loading = false
      state.success = true
      state.message = ""
      state.brands = action.payload
    },

    [getSubCategoriesList.brands]:(state) => {
      state.loading = true
    },
    [getSubCategoriesList.rejected]:(state, action) => {
      state.loading = false
      state.success = false
      state.message = action.payload?.message
    },
    [getSubCategoriesList.fulfilled]:(state, action) => {
      state.loading = false
      state.success = true
      state.message = ""
      state.subCategories = action.payload
    }
  }
});

export const { setGoogleMapApiLoaded, setModuleId } = InitialSlice.actions
export default InitialSlice.reducer;